import "./detail_bulletin.scss";
import {
  Breadcrumbs,
  Layout,
  Text,
  Heading,
} from "@netapp/bxp-design-system-react";
import { useTranslation } from "react-i18next";
import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { LangLink } from "../../../utils/langNavigation";
import axios from "axios";
import { getContentPath, loadMarkdownContent } from "../../../utils/contentLoader";

const BulletinsDetailPage = () => {
  const { i18n, t } = useTranslation();
  const [frontMatter, setFrontMatter] = useState({});
  const [content, setContent] = useState("");
  const { bulletinId } = useParams();
  const [bulletin, setBulletin] = useState(null);

  useEffect(() => {
    const loadContent = async () => {
      try {
        const filePath = getContentPath("/content/bulletins/_index", i18n.language);
        const { frontMatter: data, content: markdownContent } = await loadMarkdownContent(filePath);
        setFrontMatter(data);
        setContent(markdownContent);
      } catch (error) {
        console.error("Error loading bulletin content:", error);
      }
    };
    loadContent();
    console.log("Language:", i18n.language);
  }, [i18n.language]);

  useEffect(() => {
    // Fetch bulletin data based on the bulletin ID
    const fetchBulletin = async () => {
      try {
        const response = await axios.get(
          `${process.env.REACT_APP_API_BASE_URL}/bulletins/${bulletinId}`,
          {
            params: {
              lang: i18n.language
            }
          }
        );
        setBulletin(response?.data?.data);
        console.log("Bulletin:", response?.data?.data);
      } catch (error) {
        console.error("Error fetching bulletin:", error);
      }
    };

    fetchBulletin();
  }, [bulletinId, i18n.language]);

  if (!bulletin) {
    return <div>Loading...</div>;
  }

  return (
    <div className="bulletins-detail-page">
      <Layout.Page className="page-wrapper">
        <Layout.Content className="content-padding">
          <Layout.BreadcrumbsContainer className="breadcrumb-container">
            <Breadcrumbs>
              <LangLink to="/" className="breadcrumbs-link">
                {t("securityPortal.other")}
              </LangLink>
              <LangLink to="/bulletins" className="breadcrumbs-link">{t("bulletins.other")}</LangLink>
              {/* <div>Bulletins</div> */}
              <div>{bulletin.title}</div>
            </Breadcrumbs>
          </Layout.BreadcrumbsContainer>
          <div>
            <Text className="title">{bulletin.longtitle} </Text>
          </div>
          <div className="content-frame">
            <div className="content-items">
              <section>
                <Text>
                  Bulletin ID: {bulletin.bulletinid} Version: {bulletin.version}{" "}
                  Last Updated: {" "}
                  {new Date(bulletin.last_updated).toLocaleDateString()}
                </Text>
              </section>
              <section>
                <Heading level={3}>Applies To</Heading>
                <Text>{bulletin.applies_to}</Text>
              </section>
              {bulletin.summary && (
                <section>
                  <Heading level={3}>Summary</Heading>
                  <Text className="bulletin-content"
                    dangerouslySetInnerHTML={{
                      __html: bulletin.summary,
                    }}
                  />
                </section>
              )}
              {bulletin.associated_cve_ids?.length > 0 && (
                <section>
                  <Heading level={3}>Associated CVE IDs:</Heading>
                  <Text>{bulletin.associated_cve_ids}</Text>
                </section>
              )}
              {bulletin.references?.length > 0 && (
                <section>
                  <Heading level={3}>References</Heading>
                  <ul className="references-list">
                    {bulletin.references.map((reference, index) => (
                      <li key={index}>
                        <Text>{reference.trim()}</Text>
                      </li>
                    ))}
                  </ul>
                </section>
              )}
              <section>
                {bulletin.note && (
                  <Text
                    dangerouslySetInnerHTML={{
                      __html: bulletin.note,
                    }}
                  />
                )}
              </section>

              {bulletin.current_advisory_and_notice_documents && (
                <section>
                  <Heading level={3}>
                    Current Advisory and Notice Documents
                  </Heading>
                  <Text
                    dangerouslySetInnerHTML={{
                      __html: bulletin.current_advisory_and_notice_documents,
                    }}
                  />
                </section>
              )}

              {bulletin.table_a && (
                <section>
                  <Heading level={2}>TABLE A: Applicable CVE IDs</Heading>
                  <Text
                    dangerouslySetInnerHTML={{
                      __html: bulletin.table_a,
                    }}
                  />
                </section>
              )}
              {bulletin.table_a && (
                <section style={{ width: "100%" }}>
                  <Heading level={2}>Data ONTAP</Heading>

                  <table style={{ width: "100%" }}>
                    <tr>
                      <th style={{ width: "90%", textAlign: "left" }}>
                        <Text>CVE ID</Text>
                      </th>
                      <th style={{ width: "10%" }}>
                        <Text>Bug ID</Text>
                      </th>
                    </tr>
                    <tbody>
                      {bulletin.data_ontap_a.map((item, index) => (
                        <tr key={index}>
                          <td style={{ width: "90%", textAlign: "left" }}>
                            <Text>{item.cve_id}</Text>
                          </td>
                          <td style={{ width: "10%", textAlign: "center" }}>
                            <Text>{item.bug_id}</Text>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </section>
              )}
              {bulletin.table_a && (
                <section style={{ width: "100%" }}>
                  <Heading level={2}>
                    Management Tools and Client Products
                  </Heading>

                  <table style={{ width: "100%" }}>
                    <tr>
                      <th style={{ width: "90%", textAlign: "left" }}>
                        <Text>CVE ID</Text>
                      </th>
                      <th style={{ width: "10%" }}>
                        <Text>Bug ID</Text>
                      </th>
                    </tr>
                    <tbody>
                      {bulletin.management_tools_and_client_products_a.map(
                        (item, index) => (
                          <tr key={index}>
                            <td style={{ width: "90%", textAlign: "left" }}>
                              <Text>{item.cve_id}</Text>
                            </td>
                            <td style={{ width: "10%", textAlign: "center" }}>
                              <Text>{item.bug_id}</Text>
                            </td>
                          </tr>
                        )
                      )}
                    </tbody>
                  </table>
                </section>
              )}
              {bulletin.table_b && (
                <section>
                  <Heading level={2}>
                    TABLE B: False-Positive and Never Applicable CVE IDs
                  </Heading>
                  <Text
                    dangerouslySetInnerHTML={{
                      __html: bulletin.table_b,
                    }}
                  />
                </section>
              )}
              {bulletin.table_b && (
                <section style={{ width: "100%" }}>
                  <Heading level={2}>Data ONTAP</Heading>

                  <table style={{ width: "100%" }}>
                    <tr>
                      <th style={{ width: "90%", textAlign: "left" }}>
                        <Text>CVE ID</Text>
                      </th>
                      <th style={{ width: "10%" }}>
                        <Text>Bug ID</Text>
                      </th>
                    </tr>
                    <tbody>
                      {bulletin.data_ontap_b.map((item, index) => (
                        <tr key={index}>
                          <td style={{ width: "90%", textAlign: "left" }}>
                            <Text>{item.cve_id}</Text>
                          </td>
                          <td style={{ width: "10%", textAlign: "center" }}>
                            <Text>{item.bug_id}</Text>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </section>
              )}
              {bulletin.table_b && (
                <section style={{ width: "100%" }}>
                  <Heading level={2}>
                    Management Tools and Client Products
                  </Heading>

                  <table style={{ width: "100%" }}>
                    <tr>
                      <th style={{ width: "90%", textAlign: "left" }}>
                        <Text>CVE ID</Text>
                      </th>
                      <th style={{ width: "10%" }}>
                        <Text>Bug ID</Text>
                      </th>
                    </tr>
                    <tbody>
                      {bulletin.management_tools_and_client_products_b.map(
                        (item, index) => (
                          <tr key={index}>
                            <td style={{ width: "90%", textAlign: "left" }}>
                              <Text>{item.cve_id}</Text>
                            </td>
                            <td style={{ width: "10%", textAlign: "center" }}>
                              <Text>{item.bug_id}</Text>
                            </td>
                          </tr>
                        )
                      )}
                    </tbody>
                  </table>
                </section>
              )}
            </div>
          </div>
        </Layout.Content>
      </Layout.Page>
    </div>
  );
};

export default BulletinsDetailPage;
